import {useInfiniteQuery, useMutation} from "@tanstack/react-query";
import {apiJoinTeam, apiListTeams} from "../../../data/api/team";

export const useListTeams = (args, config) => {
    return useInfiniteQuery({
        queryKey: ['organizationList', args],
        queryFn: ({pageParam = 1}) => apiListTeams({...args, page: pageParam}),
        ...config,
        getNextPageParam: lastPage =>
            lastPage.meta.currentPage < lastPage.meta.lastPage ? lastPage.meta.currentPage + 1 : undefined,
    })
}
export const useJoinTeamsWithSearch = () => {
    return useMutation({
        mutationFn: ({code}) =>
            apiJoinTeam({
                invite_code: code,
                withSearch: true
            }),
    })
}